<template>
  <div class="container">
    <div class="home" v-show="type == 1">
      <div class="top-box">
        <div class="flexrbc">
          <div class="flexr0c">
            <div class="title-label"></div>
            <div class="title">企业用户</div>
          </div>
          <div class="addOrg flexrcc" @click="addUser">
            <img src="../../assets/imgs/home/add.png" alt />
            <div class="btn">新增用户</div>
          </div>
        </div>
      </div>
      <div class="table">
        <Table max-height="" :loading="loading1" border stripe :columns="tableHead" :data="tableData">
          <template slot-scope="{ row }" slot="roleName">
            <div class="flexr0c">
              <img v-if="row.roleName == '企业管理员'" src="../../assets/imgs/home/admin.png" alt="" />
              <div>{{ row.roleName }}</div>
            </div>
          </template>
          <template slot-scope="{ row }" slot="checkState">
            <div class="flexr0c ckeck-state">
              <img v-if="row.checkState == '已审批'" src="../../assets/imgs/home/checked.png" alt="" />
              <img v-if="row.checkState == '待审批'" src="../../assets/imgs/home/waitCheck.png" alt="" />
              <img v-if="row.checkState == '已驳回'" src="../../assets/imgs/home/reject.png" alt="" />
              <div :class="row.checkState == '已审批' ? 'checked' : row.checkState == '待审批' ? 'waitCheck' : 'reject'">
                {{ row.checkState }}
              </div>
            </div>
          </template>
          <template slot-scope="{ row, index }" slot="state">
            <div class="flexr0c">
              <i-switch :value="row.state == '1'" true-color="#27AE60" @on-change="changeState(index, $event)" v-if="row.roleName != '企业管理员'" />
              <i-switch :value="row.state == '1'" true-color="#27AE60" disabled v-if="row.roleName == '企业管理员'" />
              <div :class="row.state == '1' ? 'onSell' : 'stopSell'">
                {{ row.state == "1" ? "启用" : "停用" }}
              </div>
            </div>
          </template>
          <template class="flexr0c" slot-scope="{ row, index }" slot="action">
            <div class="flexr0c icon-box" @mouseenter="hover(index)">
              <div @click="look(index)">
                <div class="iconfont" @mouseenter="tip1 = true" @mouseleave="tip1 = false">&#xe604;</div>
                <div class="tips" v-show="tip1 && hoverIndex == index">查看</div>
              </div>
              <div v-if="row.checkState == '已审批' || row.checkState == '已驳回'" @click="edit(index)">
                <div class="iconfont" @mouseenter="tip2 = true" @mouseleave="tip2 = false">&#xe601;</div>
                <div class="tips" v-show="tip2 && hoverIndex == index">编辑</div>
              </div>
              <div v-if="row.checkState == '已审批'" @click="reset(index)">
                <div class="iconfont" @mouseenter="tip3 = true" @mouseleave="tip3 = false">&#xe607;</div>
                <div class="tips" v-show="tip3 && hoverIndex == index">重置密码</div>
              </div>
              <div v-if="row.checkState == '已驳回'" @click="del(index)">
                <div class="iconfont" @mouseenter="tip4 = true" @mouseleave="tip4 = false">&#xe603;</div>
                <div class="tips" v-show="tip4 && hoverIndex == index">删除</div>
              </div>
            </div>
          </template>
        </Table>
        <div style="margin: 10px; overflow: hidden">
          <div style="float: right">
            <Page :total="total" :page-size="pageSize" :current="1" @on-change="changePage" show-elevator show-total></Page>
          </div>
        </div>
      </div>
    </div>
    <div class="second-page" v-show="type == 2">
      <div class="top flexr0c">
        <img class="addr" src="../../assets/imgs/home/location.png" alt="" />
        <div class="title" @click="manage">企业用户</div>
        <img class="arrow" src="../../assets/imgs/home/rightarrow.png" alt="" />
        <div class="title">{{ msg }}</div>
      </div>
      <div class="content">
        <Form ref="billForm" :model="billForm" :rules="ruleValidate">
          <div class="input-box flexrbc">
            <div class="flexc0s">
              <div class="flexr0c">
                <div class="star" v-if="msg != '查看'">*</div>
                <div class="label">真实姓名</div>
              </div>
              <FormItem prop="realName">
                <Input class="adduser" v-if="msg != '查看'" v-model="billForm.realName" type="text" placeholder="请输入创建用户的真实姓名" />
              </FormItem>
              <input v-if="msg == '查看'" disabled v-model="userInfo.realName" type="text" oninput="value=value.replace(/[^\d]/g,'')" />
            </div>
            <div class="flexc0s">
              <div class="flexr0c">
                <div class="star" v-if="msg != '查看'">*</div>
                <div class="label">身份证号</div>
              </div>
              <FormItem prop="idNumber">
                <Input class="adduser" v-if="msg != '查看'" v-model="billForm.idNumber" type="text" placeholder="请输入创建用户的身份证号" />
              </FormItem>
              <input v-if="msg == '查看'" disabled v-model="userInfo.cardNo" type="text" oninput="value=value.replace(/[^\d]/g,'')" />
            </div>
          </div>
          <div class="input-box flexrbc">
            <div class="flexc0s">
              <div class="flexr0c">
                <div class="star" v-if="msg != '查看'">*</div>
                <div class="label">客户手机号</div>
              </div>
              <FormItem prop="phone">
                <Input class="adduser" maxlength="11" v-if="msg != '查看'" v-model="billForm.phone" type="text" @on-input="value = value.replace(/[^\d]/g, '')" placeholder="请输入创建用户的手机号" />
              </FormItem>
              <input v-if="msg == '查看'" disabled v-model="userInfo.phone" type="text" oninput="value=value.replace(/[^\d]/g,'')" />
            </div>
            <div class="flexc0s">
              <div class="label">设备号</div>
              <FormItem prop="deviceId">
                <Input class="adduser" v-if="msg != '查看'" v-model="billForm.deviceId" type="text" placeholder="请输入创建用户的设备号" />
              </FormItem>
              <input v-if="msg == '查看'" disabled v-model="userInfo.deviceNo" type="text" oninput="value=value.replace(/[^\d]/g,'')" />
            </div>
          </div>
          <div class="radio-box">
            <div class="flexr0c">
              <div class="star" v-if="msg != '查看'">*</div>
              <div class="label">权限</div>
            </div>
            <FormItem prop="authority">
              <RadioGroup v-if="msg != '查看'" v-model="billForm.authority" vertical>
                <Radio v-for="(item, index) in roleList" :key="index" :label="item.id">
                  <span>{{ item.name + (item.remark ? ":" + item.remark : "") }}</span>
                </Radio>
              </RadioGroup>
            </FormItem>
            <div class="value" v-if="msg == '查看'">{{ userInfo.roleName }}<span v-show="userInfo.roleRemark">：</span>{{ userInfo.roleRemark }}</div>
          </div>
          <div class="check-box">
            <div class="flexr0c">
              <div class="label">对应矿种</div>
            </div>
            <FormItem prop="checkedOption">
              <CheckboxGroup v-if="msg != '查看'" v-model="billForm.checkedOption">
                <Checkbox v-for="(item, index) in oreList" :key="index" :label="item.oreId">
                  <span>{{ item.oreName }}</span>
                </Checkbox>
              </CheckboxGroup>
            </FormItem>
            <div class="value" v-if="msg == '查看'">{{ userOreList }}</div>
          </div>
          <div class="remark-box" v-if="msg != '查看'">
            <div class="flexr0c">
              <div class="label">备注</div>
            </div>
            <FormItem prop="remark">
              <Input type="textarea" maxlength="50" v-model="billForm.remark" show-word-limit></Input>
            </FormItem>
          </div>
          <div class="split-line"></div>
          <div class="upload-box flexrbc" v-if="msg != '查看'">
            <div class="upload-item flexr0c">
              <div class="up-label">附件上传</div>
              <Button style="background-image: linear-gradient(180deg, #b4ec51 0%, #429321 100%); border: 1px solid #4c9b25; border-radius: 4px; color: white; width: 117px; height: 26px; margin-left: 16.5px" @click="showModal2">手机上传</Button>
              <Modal v-model="modal2" width="480" class-name="vertical-center-modal">
                <p slot="header" style="text-align: center">
                  <span style="color: white; font-size: 18px; font-weight: 600">手机上传</span>
                </p>
                <div style="justify-content: center; display: flex">
                  <div ref="qrcodeDiv"></div>
                </div>
                <div slot="footer" style="text-align: center">
                  <span>微信扫描二维码上传照片</span>
                </div>
              </Modal>
            </div>
          </div>
          <div class="idcard-box flexrbc">
            <div class="idcard-item">
              <div class="flexr0c localupdate-btn">
                <div class="star" v-show="msg != '查看'">*</div>
                <div class="label">身份证正面</div>
                <Upload v-show="msg != '查看'" :action="this.$baseUrl" :before-upload="handleUploadFront">
                  <Button style="background-image: linear-gradient(180deg, #5792e3 0%, #406dd8 100%); border: 1px solid #285ed3; border-radius: 4px; color: white; width: 117px; height: 26px; margin-left: 16.5px; margin-bottom: -7px">本地上传</Button>
                </Upload>
              </div>
              <FormItem prop="front">
                <div :class="frontErr ? 'img-box-err' : 'img-box'" v-if="msg != '查看'">
                  <img class="sample-img" v-if="!billForm.front" src="../../assets/imgs/home/idcard-front.png" alt="" />
                  <div v-if="billForm.front">
                    <img class="imgbg_img" :src="fileCommonUrl + billForm.front" alt="" />
                    <img @click="gobig(fileCommonUrl + billForm.front)" style="position: absolute; top: 100px; left: 160px; cursor: pointer" src="../../assets/image/gobig.png" alt="" />
                    <img @click="goremove(0)" style="position: absolute; top: 100px; left: 200px; cursor: pointer" src="../../assets/image/goremove.png" alt="" />
                  </div>
                </div>
              </FormItem>
              <div v-if="msg == '查看'">
                <img src="../../assets/imgs/qiyeziliao/noImg.png" alt="" v-if="!userInfo.frontPhoto" />
                <img class="imgbg_img" @click="gobig(fileCommonUrl + userInfo.frontPhoto)" :src="fileCommonUrl + userInfo.frontPhoto" alt="" v-else />
              </div>
              <div v-if="msg != '查看'" class="sub-txt">要求照片/扫描件内容清晰完整，无反光，露出四个边角，文件大小2M以内</div>
            </div>
            <div class="idcard-item">
              <div class="flexr0c localupdate-btn">
                <div class="star" v-if="msg != '查看'">*</div>
                <div class="label">身份证反面</div>
                <Upload v-if="msg != '查看'" :action="this.$baseUrl" :before-upload="handleUploadBack">
                  <Button style="background-image: linear-gradient(180deg, #5792e3 0%, #406dd8 100%); border: 1px solid #285ed3; border-radius: 4px; color: white; width: 117px; height: 26px; margin-left: 16.5px; margin-bottom: -7px">本地上传</Button>
                </Upload>
              </div>
              <FormItem prop="back">
                <div :class="backErr ? 'img-box-err' : 'img-box'" v-if="msg != '查看'">
                  <img class="sample-img" v-if="!billForm.back" src="../../assets/imgs/home/idcard-back.png" alt="" />
                  <div v-if="billForm.back">
                    <img class="imgbg_img" :src="fileCommonUrl + billForm.back" alt="" />
                    <img @click="gobig(fileCommonUrl + billForm.back)" style="position: absolute; top: 100px; left: 160px; cursor: pointer" src="../../assets/image/gobig.png" alt="" />
                    <img @click="goremove(1)" style="position: absolute; top: 100px; left: 200px; cursor: pointer" src="../../assets/image/goremove.png" alt="" />
                  </div>
                </div>
              </FormItem>
              <div v-if="msg == '查看'">
                <img src="../../assets/imgs/qiyeziliao/noImg.png" alt="" v-if="!userInfo.backPhoto" />
                <img class="imgbg_img" @click="gobig(fileCommonUrl + userInfo.backPhoto)" :src="fileCommonUrl + userInfo.backPhoto" alt="" v-else />
              </div>
              <div v-if="msg != '查看'" class="sub-txt">要求照片/扫描件内容清晰完整，无反光，露出四个边角，文件大小2M以内</div>
            </div>
          </div>
          <div v-if="msg != '查看'" class="submit-btn" @click="submit">提交</div>
        </Form>
      </div>
    </div>
    <div class="mask" v-if="model1 || model2">
      <div v-if="model1" class="pop-box">
        <div class="top flexrcc">
          <div class="title">重置密码</div>
          <img @click="model1 = false" src="../../assets/imgs/home/close.png" alt />
        </div>
        <div class="content flexccc">密码重置后为用户身份证后6位，确定重置？</div>
        <div class="bottom flexrcc">
          <div class="save" @click="resetConfirm">确定</div>
          <div class="cancel" @click="model1 = false">取消</div>
        </div>
      </div>
      <div v-if="model2" class="pop-box">
        <div class="top flexrcc">
          <div class="title">删除</div>
          <img @click="model2 = false" src="../../assets/imgs/home/close.png" alt />
        </div>
        <div class="content flexccc">确定删除该用户？</div>
        <div class="bottom flexrcc">
          <div class="save" @click="delComfirm">确定</div>
          <div class="cancel" @click="model2 = false">取消</div>
        </div>
      </div>
    </div>
    <!-- 查看大图 -->
    <vue-viewer ref="myViewer" className="my_class" :visible.sync="isShowBig" :images="bigUrl"></vue-viewer>
  </div>
</template>

<script>
import vueViewer from "../../components/bigImg/Viewer.vue";
import QRCode from "qrcodejs2";
export default {
  name: "companyUser",
  components: {
    vueViewer,
  },
  data () {
    const checkName = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("真实姓名不能为空"));
      } else if (!/^[\u4e00-\u9fa5]{2,4}$/.test(value)) {
        callback(new Error("请输入真实的姓名"));
      } else {
        callback();
      }
    };
    const checkPhoneNum = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("手机号码不能为空"));
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("请输入真实的手机号码"));
      } else {
        callback();
      }
    };
    const checkIdNum = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("身份证号码不能为空"));
      } else if (!/^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(value)) {
        callback(new Error("请输入真实的身份证号码"));
      } else {
        callback();
      }
    };
    return {
      loading1: false,
      total: 0,
      pageSize: 12,
      type: 1,
      index: -1,
      // msg: '新增用户',
      msg: "查看",
      kaiguan: true,
      tip1: false,
      tip2: false,
      tip3: false,
      tip4: false,
      frontErr: false, //正面照片没上传
      backErr: false, //反面照片没上传
      session: "",
      realName: "",
      idNumber: "",
      phone: "",
      deviceId: "",
      authority: "",
      remark: "",
      imgArr: [],
      isShowBig: false,
      bigUrl: [],
      userInfo: [],
      checkedOption: [],
      model1: false,
      model2: false,
      modal2: false,
      oreList: [],
      userOreList: [],
      roleList: [],
      fileCommonUrl: "",
      billForm: {
        realName: "",
        idNumber: "",
        phone: "",
        deviceId: "",
        authority: "",
        remark: "",
        front: "",
        back: "",
        checkedOption: [],
      },
      ruleValidate: {
        realName: [
          {
            required: true,
            validator: checkName,
            trigger: "blur",
          },
        ],
        idNumber: [
          {
            required: true,
            trigger: "blur",
            validator: checkIdNum,
          },
        ],
        phone: [
          {
            required: true,
            trigger: "blur",
            validator: checkPhoneNum,
          },
        ],
        authority: [
          {
            required: true,
            message: "权限不能为空",
            trigger: "change",
          },
        ],
      },
      tableHead: [
        {
          title: "用户名",
          key: "userName",
          width: 120,
          resizable: true,
        },
        {
          title: "真实姓名",
          key: "realName",
          width: 170,
          resizable: true,
        },
        {
          title: "手机号",
          key: "phone",
          width: 130,
          resizable: true,
        },
        {
          title: "权限",
          slot: "roleName",
          width: 170,
          resizable: true,
        },
        {
          title: "审批状态",
          slot: "checkState",
          width: 100,
          resizable: true,
        },
        {
          title: "账户状态",
          slot: "state",
          width: 120,
          resizable: true,
        },
        {
          title: "操作",
          slot: "action",
          width: 140,
          fixed: "right",
          resizable: true,
        },
      ],
      tableData: [],
      websock: null,
      lockReconnect: false, //是否真正建立连接
      timeout: 28 * 1000, //30秒一次心跳
      timeoutObj: null, //心跳心跳倒计时
      serverTimeoutObj: null, //心跳倒计时
      timeoutnum: null, //断开 重连倒计时
      websockHeart: true,
    };
  },
  destroyed () {
    var self = this;
    self.timeoutObj && clearTimeout(self.timeoutObj);
    self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj);
    this.websockHeart = false
  },
  methods: {
    errorTip (msg) {
      this.$Message["error"]({
        background: true,
        content: msg,
      });
    },

    addUser () {
      this.type = 2;
      this.msg = "新增用户";
      this.initForm();
    },
    initForm () {
      this.billForm.realName = "";
      this.billForm.idNumber = "";
      this.billForm.phone = "";
      this.billForm.deviceId = "";
      this.billForm.authority = "";
      this.billForm.checkedOption = [];
      this.billForm.remark = "";
      this.billForm.front = "";
      this.billForm.back = "";
    },
    hover (index) {
      this.hoverIndex = index;
    },
    changePage (page) {
      this.getList(page);
    },
    manage () {
      this.type = 1;
      this.msg = "";
      this.$refs["billForm"].resetFields();
      this.frontErr = false;
      this.backErr = false;
    },
    changeState (index, state) {
      state ? (state = 1) : (state = 2);
      var session = JSON.parse(localStorage["session"]);
      let data = {
        sessionId: session.sessionId,
        modeCode: "dwDo756MSRpO8WVm6PskItVMjDDufny2",
        id: this.tableData[index].id,
        // id: this.tableData[0].id,
        state: state,
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.getList(1);
        } else {
          this.errorTip(res.msg);
        }
      });
    },
    look (index) {
      this.index = index;
      this.getUserInfo();
      this.msg = "查看";
      this.type = 2;
    },
    edit (index) {
      this.index = index;
      this.getUserInfo2();
      this.msg = "编辑用户";
      this.type = 2;
    },
    reset (index) {
      this.index = index;
      this.model1 = true;
    },
    resetConfirm () {
      var session = JSON.parse(localStorage["session"]);
      this.$http
        .post({
          sessionId: session.sessionId,
          modeCode: "4H19sJROpWuXGhLKpRYQqsgscFbjvzQQ",
          id: this.tableData[this.index].id,
        })
        .then((res) => {
          if (res.code == 1) {
          } else {
            this.errorTip(res.msg);
          }
          this.model1 = false;
        });
    },
    del (index) {
      this.index = index;
      this.model2 = true;
    },
    delComfirm () {
      var session = JSON.parse(localStorage["session"]);
      this.$http
        .post({
          sessionId: session.sessionId,
          modeCode: "H2dwGhwUvF9CykNh8K4LAa86lBBNjGT5",
          id: this.tableData[this.index].id,
        })
        .then((res) => {
          if (res.code == 1) {
            this.getList(1);
          } else {
            this.errorTip(res.msg);
          }
          this.model2 = false;
        });
    },
    showModal2: function () {
      this.init();
      this.modal2 = true;
      function getUUID () {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
          return (c === "x" ? (Math.random() * 16) | 0 : "r&0x3" | "0x8").toString(16);
        });
      }
      let uuid = getUUID();
      setTimeout(() => {
        this.$refs.qrcodeDiv.innerHTML = "";
        var that = this;
        let href = localStorage.getItem("platUrl") + '/#/' + "uploadComUser?" + that.session.sessionId + "&" + that.session.userId;
        var qrcode = new QRCode(this.$refs.qrcodeDiv, {
          text: href, //二维码内容   url填后台给的链接
          width: 270, //控制二维码高度
          height: 270, //控制二维码宽度
          colorDark: "#000000", //控制二维码前景色
          colorLight: "#ffffff", //控制二维码背景色=
          correctLevel: QRCode.CorrectLevel.L, //设置二维码容错率
        });
      }, 100);
    },
    gobig: function (url) {
      this.isShowBig = true;
      if (this.bigUrl) {
        this.bigUrl.pop();
      }
      this.bigUrl.push(url);
    },
    goremove: function (i) {
      if (i == 0) {
        this.billForm.front = "";
      } else if (i == 1) {
        this.billForm.back = "";
      }
    },
    handleUploadFront (file) {
      if (this.billForm.front) {
        this.$Message["error"]({
          background: true,
          content: "正面照片已上传，请删除后再上传",
        });
        return;
      }
      if (this.billForm.front && this.billForm.back) {
        this.$Message["error"]({
          background: true,
          content: "正面照片已上传，请删除后再上传",
        });
        return;
      }
      const msg = this.$Message.loading({
        content: "上传中...",
        duration: 0
      });
      let that = this;
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        let file64 = e.target.result;
        let data = {
          modeCode: "DF6ylrACPgiTD0PGgs9F2l0yZHyiEO2M",
          sessionId: that.session.sessionId,
          userId: that.session.userId,
          fileName: encodeURIComponent(file.name),
          ocrType: 0,
          group: "other", //其他分组
        };
        let base64 = encodeURIComponent(file64);
        this.$http.upload(data, base64).then((res) => {
          setTimeout(msg, 300);
          if (res.code == 1) {
            this.billForm.front = res.msg;
            this.frontErr = false;
          }
        });
      };
      return false;
    },
    handleUploadBack (file) {
      if (this.billForm.back) {
        this.$Message["error"]({
          background: true,
          content: "反面照片已上传，请删除后再上传",
        });
        return;
      }
      const msg = this.$Message.loading({
        content: "上传中...",
        duration: 0
      });
      let that = this;
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        let file64 = e.target.result;
        let data = {
          modeCode: "DF6ylrACPgiTD0PGgs9F2l0yZHyiEO2M",
          sessionId: that.session.sessionId,
          userId: that.session.userId,
          fileName: encodeURIComponent(file.name),
          ocrType: 0,
          group: "other", //其他分组
        };
        let base64 = encodeURIComponent(file64);
        this.$http.upload(data, base64).then((res) => {
          setTimeout(msg, 300);
          if (res.code == 1) {
            this.billForm.back = res.msg;
            this.backErr = false;
          }
        });
      };
      return false;
    },
    init () {
      let url = localStorage.getItem("uploadFileSocketUrl") + "/" + this.session.sessionId; // 创建websocket连接
      this.websock = new WebSocket(url); // 监听打开
      this.websock.onopen = this.websockOpen; // 监听关闭
      this.websock.onclose = this.websockClose; //监听异常
      this.websock.onerror = this.websockError; //监听服务器发送的消息
      this.websock.onmessage = this.websockMessage;
    },
    websockOpen () {
      console.log("监听打开");
      //开启心跳
      this.start();
    },
    websockClose () {
      console.log("监听关闭");
      console.log(this.websockHeart)
      //重连
      if (this.websockHeart) {
        this.reconnect();
      }
    },
    websockError () {
      console.log("监听异常");
      //重连
      this.reconnect();
    },
    websockMessage (e) {
      let obj = JSON.parse(e.data);
      if (obj.msg) {
        let msg = JSON.parse(obj.msg)
        for (let i in msg) {
          if (i == "frontPhoto") {
            this.billForm.front = msg[i];
            this.frontErr = false;
          }
          if (i == "backPhoto") {
            this.billForm.back = msg[i];
            this.backErr = false;
          }
        }
      }
      this.modal2 = false;
      //收到服务器信息，心跳重置
      this.reset();
    },
    reconnect () { //重新连接
      var that = this;
      if (that.lockReconnect) {
        return;
      };
      that.lockReconnect = true;
      //没连接上会一直重连，设置延迟避免请求过多
      that.timeoutnum && clearTimeout(that.timeoutnum);
      that.timeoutnum = setTimeout(function () {
        //新连接
        that.init();
        that.lockReconnect = false;
      }, 1000);
    },
    reset () { //重置心跳
      var that = this;
      //清除时间
      clearTimeout(that.timeoutObj);
      clearTimeout(that.serverTimeoutObj);
      //重启心跳
      that.start();
    },
    start () { //开启心跳
      var self = this;
      self.timeoutObj && clearTimeout(self.timeoutObj);
      self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj);
      self.timeoutObj = setTimeout(function () {
        //这里发送一个心跳，后端收到后，返回一个心跳消息，
        if (self.websock.readyState == 1) { //如果连接正常
          self.websock.send("heartCheck");
        } else { //否则重连
          self.reconnect();
        }
        self.serverTimeoutObj = setTimeout(function () {
          //超时关闭
          self.websock.close();
        }, self.timeout);

      }, self.timeout)
    },
    getOreList () {
      var session = JSON.parse(localStorage["session"]);
      this.$http
        .post({
          sessionId: session.sessionId,
          enterpriseId: session.enterpriseId,
          modeCode: "NEKPI3BNTyQIj9lRgMmZI9jzmhrp3vjJ",
        })
        .then((res) => {
          if (res.code == 1) {
            this.oreList = res.data;
          } else {
            this.errorTip(res.msg);
          }
        });
    },
    getroleList () {
      var session = JSON.parse(localStorage["session"]);
      this.$http
        .post({
          sessionId: session.sessionId,
          modeCode: "ezLm0zKIoTb4TaqDrREaWbxqWaUy6HUe",
        })
        .then((res) => {
          if (res.code == 1) {
            this.roleList = res.data;
          } else {
            this.errorTip(res.msg);
          }
        });
    },
    submit () {
      let isValid = true;
      this.$refs["billForm"].validate((valid) => {
        if (!valid) {
          isValid = false
          return false;
        }
      });
      if (!this.billForm.front) {
        this.errorTip("请先上传身份证正面照片");
        this.frontErr = true;
      }
      if (!this.billForm.back) {
        this.errorTip("请先上传身份证反面照片");
        this.backErr = true;
      }
      if (!this.billForm.front || !this.billForm.back || !isValid) {
        return;
      }
      var session = JSON.parse(localStorage["session"]);
      if (this.msg == "编辑用户") {
        let data = {
          sessionId: session.sessionId,
          modeCode: "q7DdCjJ9KWcXJdsW8wgd70cyrXqLmgDE",
          realName: this.billForm.realName,
          id: this.tableData[this.index].id,
          phone: this.billForm.phone,
          cardNo: this.billForm.idNumber,
          roleId: this.billForm.authority,
          frontPhoto: this.billForm.front,
          backPhoto: this.billForm.back,
        };
        this.billForm.deviceId ? (data.deviceNo = this.billForm.deviceId) : data;
        this.billForm.remark ? (data.remark = this.billForm.remark) : data;
        this.billForm.checkedOption.length != 0 ? (data.oreIds = this.billForm.checkedOption.join()) : data;
        this.$http.post(data).then((res) => {
          if (res.code == 1) {
            this.type = 1;
            this.getList(1);
          } else {
            this.errorTip(res.msg);
          }
        });
      } else if (this.msg == "新增用户") {
        let data = {
          sessionId: session.sessionId,
          modeCode: "oKlbLlQof91aC9NLPvuIsxbB2eHb07Bv",
          realName: this.billForm.realName,
          phone: this.billForm.phone,
          cardNo: this.billForm.idNumber,
          roleId: this.billForm.authority,
          frontPhoto: this.billForm.front,
          backPhoto: this.billForm.back,
        };
        this.billForm.deviceId ? (data.deviceNo = this.billForm.deviceId) : data;
        this.billForm.remark ? (data.remark = this.billForm.remark) : data;
        this.billForm.checkedOption.length != 0 ? (data.oreIds = this.billForm.checkedOption.join()) : data;
        this.$http.post(data).then((res) => {
          if (res.code == 1) {
            this.type = 1;
            this.getList(1);
          } else {
            this.errorTip(res.msg);
          }
        });
      }
    },
    getUserInfo () {
      var session = JSON.parse(localStorage["session"]);
      let data = {
        sessionId: session.sessionId,
        modeCode: "JBJDctJU7to4gK6Dj1y2jHps6lyXjz4B",
        id: this.tableData[this.index].id,
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          var a = [];
          res.data.oreList.forEach((item) => {
            a.push(item.oreName);
          });
          this.userOreList = a.join();
          this.userInfo = res.data;
        } else {
          this.errorTip(res.msg);
        }
      });
    },
    getUserInfo2 () {
      var session = JSON.parse(localStorage["session"]);
      let data = {
        sessionId: session.sessionId,
        modeCode: "JBJDctJU7to4gK6Dj1y2jHps6lyXjz4B",
        id: this.tableData[this.index].id,
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          var a = [];
          var b = [];
          res.data.oreList.forEach((item) => {
            a.push(item.oreName);
            b.push(item.oreId);
          });
          this.userOreList = a.join();
          var userInfo = res.data;
          this.billForm.realName = userInfo.realName;
          this.billForm.idNumber = userInfo.cardNo;
          this.billForm.phone = userInfo.phone;
          this.billForm.deviceId = userInfo.deviceNo;
          this.billForm.authority = userInfo.role;
          this.billForm.checkedOption = b;
          this.billForm.remark = userInfo.remark;
          this.billForm.front = userInfo.frontPhoto;
          this.billForm.back = userInfo.backPhoto;
        } else {
          this.errorTip(res.msg);
        }
      });
    },
    getList (index) {
      var session = JSON.parse(localStorage["session"]);
      let data = {
        sessionId: session.sessionId,
        modeCode: "3iYRu1pMXaGtEDXK3gQvO2s9UqGZu0pj",
        enterpriseId: session.enterpriseId,
        pageIndex: index,
        pageSize: this.pageSize,
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          res.data.list.forEach((item) => {
            if (item.checkState == 0) item.checkState = "待审批";
            if (item.checkState == 1) item.checkState = "已审批";
            if (item.checkState == 2) item.checkState = "已驳回";
          });
          this.total = res.data.count;
          this.tableData = res.data.list;
        } else {
          this.errorTip(res.msg);
        }
      });
    },
  },
  created () {
    var session = JSON.parse(localStorage["session"]);
    this.session = session;
    this.fileCommonUrl = localStorage.getItem("fileCommonUrl");
    this.getList(1);
    this.getroleList();
    this.getOreList();
  },
};
</script>

<style lang="less" scoped>
/deep/ .ivu-btn-primary {
  background-image: linear-gradient(180deg, #5792e3 0%, #406dd8 100%);
  margin: 0 10px;
}

/deep/ .ivu-modal-header {
  background-image: linear-gradient(180deg, #5792e3 0%, #2c59c3 100%);
  border-radius: 10px 10px 0 0;
  overflow: hidden;
  height: 48px;
}

/deep/ .ivu-modal-content {
  border-radius: 10px;
}

/deep/ .ivu-modal-close .ivu-icon-ios-close {
  color: white;
}

.container {
  width: 980px;
  height: 100%;
  text-align: center;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin-left: 20px;
  background: #fff;

  .home {
    .top-box {
      background-image: linear-gradient(180deg, #ffffff 0%, #e8e9ea 100%);
      border-radius: 10px 10px 0 0;
      width: 100%;
      height: 40px;

      & > div {
        height: 100%;
        width: 928px;
        margin: 0 auto;
      }

      .title-label {
        width: 4px;
        height: 14px;
        background: #2c59c3;
      }

      .title {
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #2c59c3;
        letter-spacing: 0.4px;
        margin-left: 6px;
      }

      .addOrg {
        background-image: linear-gradient(180deg, #b4ec51 0%, #429321 100%);
        border: 1px solid #4c9b25;
        border-radius: 6px;
        width: 110px;
        height: 30px;
        cursor: pointer;

        &:hover {
          background-image: linear-gradient(180deg, #c4ff5b 0%, #4aa824 100%);
        }

        img {
          width: 14px;
          height: 14px;
          margin-right: 5px;
        }

        .btn {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0.35px;
        }
      }
    }

    .table {
      width: 928px;
      margin: 18px 0 0 26px;

      /deep/.ivu-table-cell {
        padding-left: 12px;
        overflow: unset;
      }

      .ckeck-state {
        img {
          margin-right: 6px;
          width: 14px;
          height: 14px;
        }

        .checked {
          color: #f5a623;
        }

        .waitCheck {
          color: #5cae50;
        }

        .reject {
          color: #d0021b;
        }
      }

      .onSell {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #27ae60;
        letter-spacing: 0;
        margin-left: 5px;
      }

      .stopSell {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #d0021b;
        letter-spacing: 0;
        margin-left: 5px;
      }

      .icon-box {
        & > div {
          position: relative;

          &:hover {
            color: #4a90e2 !important;
          }

          &:last-child {
            &:hover {
              color: #d0021b !important;
            }
          }
        }

        .iconfont {
          margin-right: 20px;
          cursor: pointer;

          &:last-child {
            margin-right: 0;
          }
        }

        .tips {
          position: absolute;
          left: 10px;
          top: -10px;
          width: 48px;
          height: 15px;
          line-height: 15px;
          font-family: PingFangSC-Regular;
          font-size: 12px;
          background-color: #ffffff;
          color: #9b9b9b;
          letter-spacing: 0;
        }
      }
    }
  }

  .second-page {
    width: 980px;
    // height: 980px;
    background: #ffffff;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    position: relative;

    .top {
      .addr {
        width: 14px;
        height: 18px;
        margin: 15px;
        margin-right: 8px;
      }

      .title {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #adb2bc;
        letter-spacing: 0.26px;
        cursor: pointer;
      }

      .arrow {
        width: 7px;
        height: 14px;
        margin: 0 10px;
      }
    }

    .content {
      width: 860px;
      min-height: 775px;
      overflow: hidden;

      .value {
        text-align: left;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #4a4a4a;
        letter-spacing: 0.26px;
      }

      .star {
        font-size: 10px;
        color: red;
        margin-right: 10px;
      }

      .label {
        font-family: PingFangSC-Semibold;
        font-size: 14px;
        color: #9097a9;
        letter-spacing: 0.26px;
        line-height: 20px;
        margin: 8px 0;
      }

      .input-box {
        &:nth-child(2) {
          margin-top: 15px;
        }

        input,
        /deep/.ivu-input {
          width: 368px;
          height: 48px;
          // background: #F5F7FA;
          border-radius: 8px;
          padding-left: 24px;
          font-size: 14px;
          box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.07);
        }

        .adduser {
          background: #ffffff;
          // border: 1px solid #DFDFDF;
          box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.07);
          border-radius: 8px;
          font-size: 14px;
        }
      }

      .radio-box {
        margin-top: 15px;

        /deep/.ivu-form-item-content {
          text-align: left;
          width: 100%;
        }

        // /deep/.ivu-radio-group {
        //     text-align: left;
        //     width: 100%;
        // }

        /deep/.ivu-radio {
          margin-right: 10px;
        }

        /deep/.ivu-radio-wrapper {
          font-family: PingFangSC-Regular;
          font-size: 16px;
          color: #4a4a4a;
          letter-spacing: 0.3px;
          display: table;
        }

        // /deep/.ivu-radio-group-vertical .ivu-radio-wrapper

        /deep/.ivu-form-item {
          margin-bottom: 0;
        }
      }

      .check-box {
        margin-top: 20px;

        /deep/.ivu-checkbox-group-item {
          display: table;
          margin-bottom: 5px;
          text-align: left;
        }

        /deep/.ivu-checkbox + span,
        /deep/.ivu-checkbox-wrapper + span {
          margin-left: 10px;
          font-family: PingFangSC-Regular;
          font-size: 16px;
          color: #4a4a4a;
          letter-spacing: 0.3px;
        }

        /deep/.ivu-form-item {
          margin-bottom: 0;
        }
      }

      .remark-box {
        /deep/ textarea.ivu-input {
          height: 100px;
          background: #ffffff;
          // border: 1px solid #DFDFDF;
          box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
          border-radius: 8px;
          resize: none;
        }
      }

      .split-line {
        width: 860px;
        height: 1px;
        border: 1px dashed #ebedf3;
        margin: 20px 0 26px 0;
      }

      .upload-box {
        margin-bottom: 10px;

        .upload-item {
          width: 410px;

          .up-label {
            font-family: PingFangSC-Semibold;
            font-size: 14px;
            color: #2c59c3;
            letter-spacing: 0.25px;
          }

          .btn {
            border-radius: 4px;
            font-family: PingFangSC-Medium;
            font-size: 14px;
            color: #ffffff;
            letter-spacing: 0.35px;
            text-align: center;
            width: 117px;
            height: 26px;
            cursor: pointer;
          }

          .phone-upload {
            background-image: linear-gradient(180deg, #b4ec51 0%, #429321 100%);
            border: 1px solid #4c9b25;
            margin: 0 16px;

            &:hover {
              background-image: linear-gradient(
                180deg,
                #c4ff5b 0%,
                #4aa824 100%
              );
            }
          }

          .location-upload {
            background-image: linear-gradient(180deg, #5792e3 0%, #406dd8 100%);
            border: 1px solid #285ed3;

            &:hover {
              background-image: linear-gradient(
                180deg,
                #5295f5 0%,
                #2559d1 99%
              );
            }
          }
        }
      }

      .idcard-box {
        .idcard-item {
          width: 410px;

          .localupdate-btn {
            margin-bottom: 10px;
            margin-top: 5px;
          }

          .img-box {
            width: 368px;
            height: 210px;
            background: #ffffff;
            border: 1px solid #ccd1dd;
            border-radius: 4px;
            position: relative;

            .sample-img {
              margin-top: 25px;
            }
          }

          .img-box-err {
            width: 368px;
            height: 210px;
            background: #ffffff;
            border: 1px solid red;
            border-radius: 4px;
            position: relative;

            .sample-img {
              margin-top: 25px;
            }
          }

          .imgbg_img {
            margin-top: 4px;
            width: 360px;
            height: 200px;
          }

          .sub-txt {
            margin-top: 10px;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #616c84;
            letter-spacing: 0.21px;
          }
        }
      }

      .submit-btn {
        width: 368px;
        height: 48px;
        line-height: 48px;
        background-image: linear-gradient(180deg, #d3e2ff 0%, #a8c2ff 100%);
        border: 1px solid #b2c9ff;
        border-radius: 8px;
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #ffffff;
        letter-spacing: 0.3px;
        text-align: center;
        margin: 60px 0 74px 246px;
        cursor: pointer;

        &:hover {
          background-image: linear-gradient(180deg, #478ee9 0%, #2255ce 100%);
        }
      }
    }
  }

  .mask {
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;

    .pop-box {
      width: 480px;
      height: 282px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;

      .top {
        width: 100%;
        height: 46px;
        background-image: linear-gradient(180deg, #5792e3 0%, #2c59c3 100%);
        border-radius: 10px 10px 0 0;

        .title {
          font-family: PingFangSC-Semibold;
          font-size: 18px;
          color: #ffffff;
          letter-spacing: 0.34px;
        }

        img {
          position: absolute;
          float: right;
          width: 16px;
          height: 16px;
          right: 15px;
          cursor: pointer;
        }
      }

      .content {
        width: 100%;
        height: 186px;
        background-color: #ffffff;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #4a4a4a;
        letter-spacing: 0;
      }

      .bottom {
        // transform: scaleY(-1);
        background: #f5f5f5;
        border-radius: 0 0 10px 10px;
        height: 50px;

        .cancel {
          width: 138px;
          height: 30px;
          line-height: 30px;
          background-image: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.97) 0%,
            rgba(251, 251, 251, 0.98) 37%,
            #f5f5f5 100%
          );
          border: 1px solid #cacaca;
          border-radius: 4px;
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #000000;
          letter-spacing: 0;
          margin-left: 16px;
          text-align: center;
          cursor: pointer;

          &:hover {
            background-image: linear-gradient(
              180deg,
              rgba(255, 255, 255, 0.97) 0%,
              rgba(251, 251, 251, 0.98) 37%,
              #e9e9e9 100%
            );
          }
        }

        .save {
          width: 138px;
          height: 30px;
          line-height: 30px;
          background-image: linear-gradient(180deg, #478ee9 0%, #2255ce 100%);
          border: 1px solid #285ed3;
          border-radius: 4px;
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0;
          text-align: center;
          cursor: pointer;

          &:hover {
            background-image: linear-gradient(180deg, #5295f5 0%, #2559d1 99%);
          }
        }
      }
    }
  }

  /deep/ .vertical-center-modal {
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: linear-gradient(180deg, #5792e3 0%, #2c59c3 100%);

    .ivu-modal {
      top: 0;
    }
  }

  /deep/ .ivu-btn-primary {
    background-image: linear-gradient(180deg, #5792e3 0%, #406dd8 100%);
    margin: 0 10px;
  }

  /deep/ .ivu-modal-header {
    background-image: linear-gradient(180deg, #5792e3 0%, #2c59c3 100%);
    border-radius: 10px 10px 0 0;
    overflow: hidden;
    height: 48px;
  }

  /deep/.ivu-table-wrapper-with-border {
    border-radius: 12px;
  }

  /deep/ .ivu-table th {
    background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
    color: #fff;
  }

  /deep/ .ivu-table th:first-child {
    // border-top-left-radius: 10px;
    background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
    color: #fff;
  }

  /deep/ .ivu-table th:last-child {
    border-top-right-radius: 10px;
    background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
    color: #fff;
  }

  /deep/.ivu-select-selected-value,
  /deep/.ivu-select-item {
    text-align: left;
    border-bottom: 1px solid #fafafa;
  }

  /deep/span.ivu-select-selected-value {
    border-bottom: none;
  }

  /deep/.ivu-select-item:last-child {
    border-bottom: none;
  }

  /deep/.ivu-radio-inner:after {
    background-color: #2c59c3;
  }

  /deep/.ivu-radio-checked .ivu-radio-inner {
    border-color: #2c59c3;
  }

  /deep/.ivu-table-stripe .ivu-table-body tr:nth-child(2n) td,
  .ivu-table-stripe .ivu-table-fixed-body tr:nth-child(2n) td {
    background-color: rgba(236, 241, 247, 0.4);
  }

  /deep/.ivu-table-stripe .ivu-table-body tr.ivu-table-row-hover td,
  .ivu-table-stripe .ivu-table-fixed-body tr.ivu-table-row-hover td {
    background: rgba(255, 255, 235, 0.15) !important;
  }

  /deep/.ivu-table-row-hover {
    background: rgba(255, 255, 235, 0.15) !important;
  }

  /deep/.ivu-input-with-suffix {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.07);
  }

  /deep/.ivu-table-wrapper-with-border {
    border-radius: 12px;
    border: 1px solid #dcdee2;
    border-right: none;
  }

  /deep/.ivu-table td,
  .ivu-table th {
    border-bottom: none;
  }

  /deep/.ivu-table:before {
    display: none;
  }

  input:disabled {
    background: #f5f7fa;
    border: 1px solid rgba(118, 118, 118, 0.3);
    box-shadow: none;
  }

  /deep/.ivu-input[disabled] {
    color: #000;
  }

  /deep/.ivu-form-item {
    margin-bottom: 0;
  }
}
</style>
